module.exports = __webpack_public_path__ + "build/img/man2.d75e5066.png";